import React from 'react';
import { IIconProps } from '../interfaces';
import { useTheme } from '@chakra-ui/react';

const AleaArchiveIcon: React.FC<IIconProps> = ({
  color,
  size = '21',
}) => {
  const theme = useTheme();
  const iconColor = color || theme.colors.sunsetEmber[500];
  const width = parseInt(String(size), 10);
  const height = (22 / 21) * width;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49609 6.61816H19.3632V18.3216C19.3632 19.9784 18.02 21.3216 16.3632 21.3216H4.49609C2.83924 21.3216 1.49609 19.9784 1.49609 18.3216V6.61816Z"
        fill={iconColor}
      />
      <path
        d="M13.6387 10.2246H7.22135"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M0.496094 3.67773C0.496094 2.02088 1.83924 0.677734 3.49609 0.677734H17.3629C19.0198 0.677734 20.3629 2.02088 20.3629 3.67773V5.02896H0.496094V3.67773Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default AleaArchiveIcon; 